"use client";

import { c as _c } from "react/compiler-runtime";
import { useAIChatInputContext } from "../contexts";
import { useCallback } from "react";
import TiptapEditor from "@/components/tiptap/editor";
import { cx } from "@/lib/tailwind-utils";
import type { SuggestionItem } from "@/types/suggestions";
interface AIChatInputTextAreaProps {
  placeholder?: string;
  className?: string;
  /** Accessible name for the contenteditable editor */
  ariaLabel?: string;
  /** @-mention catalog for TipTap */
  mentionSuggestions?: SuggestionItem[];
  /** Async mention search */
  onSearchMentions?: (query: string) => Promise<SuggestionItem[]>;
  /** Return false to block opening the mention menu */
  onMentionMenuOpen?: () => boolean;
}
export function AIChatInputTextArea(t0) {
  const $ = _c(18);
  const {
    placeholder: t1,
    className,
    ariaLabel,
    mentionSuggestions: t2,
    onSearchMentions,
    onMentionMenuOpen
  } = t0;
  const placeholder = t1 === undefined ? "Ask a question..." : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const mentionSuggestions = t3;
  const {
    state,
    actions
  } = useAIChatInputContext();
  let t4;
  if ($[2] !== actions) {
    t4 = (_text, _html, completeText) => {
      actions.setText(completeText);
    };
    $[2] = actions;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const handleContentUpdate = t4;
  let t5;
  if ($[4] !== actions) {
    t5 = () => {
      actions.send();
    };
    $[4] = actions;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const handleEnter = t5;
  let t6;
  if ($[6] !== className) {
    t6 = cx("flex-1 border-none outline-none min-h-12 max-h-40", className);
    $[6] = className;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== ariaLabel || $[9] !== handleContentUpdate || $[10] !== handleEnter || $[11] !== mentionSuggestions || $[12] !== onMentionMenuOpen || $[13] !== onSearchMentions || $[14] !== placeholder || $[15] !== state.text || $[16] !== t6) {
    t7 = <TiptapEditor editorClassName={t6} parentClassName="flex-1 min-w-0" content={state.text} onUpdate={handleContentUpdate} onEnter={handleEnter} suggestions={mentionSuggestions} onSearchSuggestions={onSearchMentions} onSuggestionOpen={onMentionMenuOpen} textArea={false} focusClasses={false} placeholder={placeholder} ariaLabel={ariaLabel} />;
    $[8] = ariaLabel;
    $[9] = handleContentUpdate;
    $[10] = handleEnter;
    $[11] = mentionSuggestions;
    $[12] = onMentionMenuOpen;
    $[13] = onSearchMentions;
    $[14] = placeholder;
    $[15] = state.text;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}